// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ij_A","content":"styles_content__382zn","tableWrap":"styles_tableWrap__OPbZX"};